// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VendorsPage.css */

/* 1. MAIN LAYOUT FIX */
.vendors-page {
  padding: 24px; /* Adds space so it doesn't touch the edges/sidebar */
  width: 100%;
  box-sizing: border-box;
  animation: fadeIn 0.5s ease-in-out;
  background-color: #F9FAFB; /* Optional: Matches common dashboard backgrounds */
  min-height: 0;
}

/* 2. HEADER ALIGNMENT */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.page-header h3 {
  color: #174078;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* 3. CONTROLS (Search + Button) */
.page-controls {
  display: flex;
  align-items: center;
  gap: 16px; /* Spacing between search bar and button */
}

/* Search Bar Styling */
.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 8px 12px;
  width: 320px; /* Fixed width for consistency */
  transition: box-shadow 0.2s;
}

.page-search-bar:focus-within {
  border-color: #F97316; /* Highlights orange when typing */
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);
}

.page-search-bar img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  opacity: 0.5;
}

.page-search-bar input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  color: #374151;
  background: transparent;
}

/* 4. BUTTON STYLING */
.create-vendor-btn {
  background-color: #F97316;  
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap; /* Prevents text wrapping */
  height: 40px; /* Matches search bar height */
  display: flex;
  align-items: center;
  justify-content: center;
}

.create-vendor-btn:hover {
  background-color: #ea580c;
}

/* 5. TABLE CONTAINER */
.table-container {
  background: white;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  overflow-x: auto; /* Handles scrolling on small screens */
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.data-table th {
  background-color: #F9FAFB;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #174078;
  text-transform: uppercase;
  border-bottom: 1px solid #E5E7EB;
}

.data-table td {
  padding: 16px;
  font-size: 14px;
  color: #4B5563;
  border-bottom: 1px solid #F3F4F6;
  vertical-align: middle;
}

.data-table tr:last-child td {
  border-bottom: none;
}

/* Action Icon */
.action-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.action-icon:hover {
  opacity: 1;
}

/* 6. STATUS BADGES */
.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}

.status-active {
  background-color: #DEF7EC;  
  color: #046C4E;
}

.status-inactive {
  background-color: #FEE2E2;  
  color: #991B1B;
}

/* 7. PAGINATION FOOTER */
.page-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

.pagination-controls {
  display: flex;
  gap: 8px;
}

.pagination-controls button {
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #F9FAFB;
}

.pagination-controls button:not(:disabled):hover {
  border-color: #F97316;
}

/* 8. EMPTY STATE */
.page--empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60vh; /* Adjusted height */
  text-align: center;
  background: white; /* Optional: white box for empty state */
  border-radius: 8px;
  margin-top: 20px;
}

.page--empty img {
  width: 100px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.page--empty h3 {
  font-size: 18px;
  font-weight: 500;
  color: #6B7280;
  margin: 0;
}

/* Animation */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 768px) {
  .vendors-page .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .vendors-page .page-controls {
    width: 100%;
    flex-wrap: wrap;
  }

  .vendors-page .page-search-bar {
    max-width: 100%;
    flex: 1 1 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/VendorsPage/VendorsPage.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,uBAAuB;AACvB;EACE,aAAa,EAAE,qDAAqD;EACpE,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB,EAAE,mDAAmD;EAC9E,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,0CAA0C;AACvD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY,EAAE,gCAAgC;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB,EAAE,kCAAkC;EACzD,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,mBAAmB,EAAE,2BAA2B;EAChD,YAAY,EAAE,8BAA8B;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB,EAAE,uCAAuC;EACzD,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,oBAAoB;EAClC,kBAAkB;EAClB,iBAAiB,EAAE,wCAAwC;EAC3D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,cAAc;AACd;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":["/* VendorsPage.css */\n\n/* 1. MAIN LAYOUT FIX */\n.vendors-page {\n  padding: 24px; /* Adds space so it doesn't touch the edges/sidebar */\n  width: 100%;\n  box-sizing: border-box;\n  animation: fadeIn 0.5s ease-in-out;\n  background-color: #F9FAFB; /* Optional: Matches common dashboard backgrounds */\n  min-height: 0;\n}\n\n/* 2. HEADER ALIGNMENT */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.page-header h3 {\n  color: #174078;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* 3. CONTROLS (Search + Button) */\n.page-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px; /* Spacing between search bar and button */\n}\n\n/* Search Bar Styling */\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 8px 12px;\n  width: 320px; /* Fixed width for consistency */\n  transition: box-shadow 0.2s;\n}\n\n.page-search-bar:focus-within {\n  border-color: #F97316; /* Highlights orange when typing */\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);\n}\n\n.page-search-bar img {\n  width: 16px;\n  height: 16px;\n  margin-right: 10px;\n  opacity: 0.5;\n}\n\n.page-search-bar input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 14px;\n  color: #374151;\n  background: transparent;\n}\n\n/* 4. BUTTON STYLING */\n.create-vendor-btn {\n  background-color: #F97316;  \n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap; /* Prevents text wrapping */\n  height: 40px; /* Matches search bar height */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.create-vendor-btn:hover {\n  background-color: #ea580c;\n}\n\n/* 5. TABLE CONTAINER */\n.table-container {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  overflow-x: auto; /* Handles scrolling on small screens */\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.data-table th {\n  background-color: #F9FAFB;\n  padding: 12px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #174078;\n  text-transform: uppercase;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.data-table td {\n  padding: 16px;\n  font-size: 14px;\n  color: #4B5563;\n  border-bottom: 1px solid #F3F4F6;\n  vertical-align: middle;\n}\n\n.data-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Action Icon */\n.action-icon {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.action-icon:hover {\n  opacity: 1;\n}\n\n/* 6. STATUS BADGES */\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.status-active {\n  background-color: #DEF7EC;  \n  color: #046C4E;\n}\n\n.status-inactive {\n  background-color: #FEE2E2;  \n  color: #991B1B;\n}\n\n/* 7. PAGINATION FOOTER */\n.page-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20px;\n}\n\n.pagination-info {\n  font-size: 14px;\n  color: #6B7280;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.pagination-controls button {\n  background: white;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #F9FAFB;\n}\n\n.pagination-controls button:not(:disabled):hover {\n  border-color: #F97316;\n}\n\n/* 8. EMPTY STATE */\n.page--empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 60vh; /* Adjusted height */\n  text-align: center;\n  background: white; /* Optional: white box for empty state */\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.page--empty img {\n  width: 100px;\n  margin-bottom: 16px;\n  opacity: 0.6;\n}\n\n.page--empty h3 {\n  font-size: 18px;\n  font-weight: 500;\n  color: #6B7280;\n  margin: 0;\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 768px) {\n  .vendors-page .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .vendors-page .page-controls {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .vendors-page .page-search-bar {\n    max-width: 100%;\n    flex: 1 1 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
